export const SMOKER = 'smoker'
export const DOCTOR = 'doctor'
